import authConfig from '../config/authConfig'
import globals from '../config/appconfig'
import Ruoli from "../utils/Ruoli";

export default class SessioneUtente {

    sessionId = null;
    dataScadenzaToken = null;
    idUtente = null;
    nomeUtente = null;
    cognomeUtente = null;
    ruoliUtente = null;
    stateCode = null;
    codiceStruttura = null;
    strutturaHIV = null;
    tokenExpirationTime = null;
    samlToken = null;
    samlTokenExpirationTime = null;
    samlLatestUpdate = null;
    idApplicazione = null;
    idToken = null;
    testaRefreshToken = null;
    sessionTimeOut = null;
    sessionExpirationTime = null;
    sessionCreatedTime = null;
    sessionCreationTimestamp = null;

    static instance = null;

    constructor(authParams) {
        this.sessionInit(authParams)
    }

    static getInstance(authParams) {
        if (authParams) {
            this.instance = new SessioneUtente(authParams);
        }
        return this.instance;
    }

    static editInstance(field, value) {
        if (this.instance != null) {
            this.instance[field] = value;
        }
    }

    static destroySession() {
        this.instance = null;
        console.log('[DEBUG] Session successfully cleared.')
    }

    sessionInit = (authParams) => {
        //  Init session parameter
        if (!this.sessionCreatedTime) {
            this.SessionCreatedTime = Date.now()
        }
        this.SessionLatestUpdate = Date.now()
        this.SessionTimeOut = authConfig['SessionTimeOut']
        this.SessionExpirationTime = authConfig['SessionExpirationTime']
        //  Init auth parameter
        this.sessionId = authParams.sessionId
        this.idUtente = authParams["cognito:username"] ? authParams["cognito:username"] : authParams.userid
        this.nomeUtente = authParams.given_name ? authParams.given_name : authParams.userName
        this.cognomeUtente = authParams.family_name ? authParams.family_name : authParams.userSurname
        this.codiceFiscale = authParams["custom:codice_fiscale"] ? authParams["custom:codice_fiscale"] : authParams.CodiceFiscale
        this.ruoliUtente = authParams["apms:gruppi"] ? authParams["apms:gruppi"] : authParams.userRoles
        this.strutturaHIV = authParams["apms:SIRMI-HIV-STRUTTURA"] ? authParams["apms:SIRMI-HIV-STRUTTURA"] : authParams.StrutturaHIV
        this.stateCode = authParams.state ? authParams.state : ""
        this.codiceStruttura = authParams["custom:codice_struttura"] ? authParams["custom:codice_struttura"] : authParams.CodiceStruttura
        if (process.env.REACT_APP_STRUTTURA_FAKE && (this.ruoliUtente === Ruoli.Operatore_Sisp.descrizione || this.ruoliUtente === Ruoli.Operatore_Sisp_HIV.descrizione) && this.codiceStruttura === "local") {
            this.ulss = "050508"
        } else {
            this.ulss = this.codiceStruttura === "local" ? "" : this.codiceStruttura
        }
        this.idApplicazione = globals['app-id-applicazione']
        console.log('[DEBUG] Sessione istanziata ')
    }

    static existsSession() {
        return SessioneUtente.getInstance() != null
    }

    static isSessionExpired() {
        console.log('[DEBUG] Session:')
        console.log(SessioneUtente.getInstance())

        let sessionTimeOut = SessioneUtente.getInstance().SessionTimeOut
        let sessionLatestUpdate = SessioneUtente.getInstance().SessionLatestUpdate
        let sessionCreatedTime = SessioneUtente.getInstance().SessionCreatedTime
        let sessionExpirationTime = SessioneUtente.getInstance().SessionExpirationTime
        let LatestActivityTime = authConfig["LatestActivityTime"]

        let timestamp = Date.now()

        // Minutes from last operation
        let minutesFromLastOp = (timestamp - sessionLatestUpdate) / 1000 / 60

        // Minutes from last operation
        let minutesFromLastAct = (timestamp - LatestActivityTime) / 1000 / 60

        // Hours from creation
        let hoursFromCreation = (timestamp - sessionCreatedTime) / 1000 / 3600

        // Session expired => destroy session and return to login
        if ((minutesFromLastAct >= sessionTimeOut) || (minutesFromLastOp >= sessionTimeOut) || (hoursFromCreation >= sessionExpirationTime)) {
            this.destroySession();
            return true
        }
    }

}
 